<template>
  <div id="messaging-block">
    <mdb-card class="mb-4">
      <mdb-card-header class="border-0 font-weight-bold text-left">
        <h4 v-if="headerTitle">{{headerTitle}}</h4>
        <span v-if="!totalComments && type!='forum'">No {{labels.pluralType}}</span>
        <span v-if="totalComments">
          <span v-if="type!='forum'">{{totalComments}} {{totalComments == 1 ? labels.type : labels.pluralType}}</span>
          <span v-if="showingText && type!='forum'">{{showingText}}</span>
          <span class="small" v-if="order=='asc'">{{$t("common.messaging.showingOldestToNewest")}}</span>
          <span class="small" v-if="order=='desc'">{{$t("common.messaging.showingNewestToOldest")}}</span>
        </span>
        <h5 v-if="readOnly">
          <i>New {{labels.pluralType}} have been disabled.</i>
        </h5>

        <div class="toolbar-buttons">
          <mdb-btn @click="returnTopics" icon="arrow-left" rounded size="sm" v-if="type=='forum'">
            Topics List
          </mdb-btn>

          <mdb-btn @click="addDialog=true" icon="comment-plus" rounded size="sm"
                   v-if="order=='desc' && type!='forum' && !blocked && type != 'conversation' && !readOnly">{{$t("common.button.add")}} {{labels.type}}
          </mdb-btn>
          <mdb-btn @click="addDialog=true" icon="comment-plus" rounded size="sm"
                   v-if="order=='desc' && type!='forum' && !blocked && type == 'conversation' && !readOnly">{{$tc("common.messaging.reply",1)}}
          </mdb-btn>

          <mdb-btn @click="refresh" icon="sync" rounded size="sm">{{ $t("common.button.refresh")}}</mdb-btn>
          <span v-if="totalComments>0">
            <mdb-btn @click="changeDir('asc')" icon="arrow-down" rounded size="sm" v-if="order=='desc'">
              {{ $t("common.button.sort" )}}
            </mdb-btn>
            <mdb-btn @click="changeDir('desc')" icon="arrow-up" rounded size="sm" v-if="order=='asc'">{{ $t("common.button.sort" )}}
            </mdb-btn>
          </span>
        </div>

        <div class="small" v-html="showingTextSmall" v-if="showingTextSmall"/>
        <mdb-spinner v-if="loading"/>

      </mdb-card-header>
    </mdb-card>
    <div :key="comment.id" v-for="comment in comments">
      <message-content :allowReply="allowReply" :comment="comment" :highlight="highlight" :id="id"
                       :type="type"
                       :readOnly="readOnly"
                       :labels="labels"
                       @deleted="commentDeleted"
                       @replyDeleted="replyDeleted"/>
    </div>
    <mdb-btn :disabled="loading" @click="loadMessages" icon="chevron-circle-down" v-if="nextOffset != 0 ">{{ $t("common.button.loadMore" )}}
    </mdb-btn>
    <mdb-btn @click="addDialog=true" icon="comment-plus" v-if="order=='asc' && !blocked && type!='forum' && type != 'conversation' && !readOnly">{{ $t("common.button.add" )}}
      {{labels.type}}
    </mdb-btn>
    <mdb-btn @click="addDialog=true" icon="comment-plus" v-if="order=='asc' && !blocked && type!='forum' && type == 'conversation' && !readOnly">{{ $tc("common.messaging.reply" )}}
    </mdb-btn>
    <message-create :requireSubject="type=='forum'" @cancel="addDialog=false"
                    @save="postComment"
                    allow-file-upload
                    :label="$t('common.messaging.writeNew') + ' ' + labels.type"
                    :button-label="labels.buttonLabel"
                    :body-placeholder="bodyPlaceholder"
                    v-if="addDialog"
    />
  </div>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import messageContent from "./MessageContent";
import messageCreate from "./MessageCreate"
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbSpinner
} from 'mdbvue';

export default {
    name: 'messaging',
    components: {
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbSpinner,
      messageContent,
      messageCreate,
      mdbIcon,
      mdbBtn,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbContainer
    },
    props: {
      type: {
        type: String,
        default: null
      },
      headerTitle: {
        type: String,
        default: null
      },
      id: {
        type: Number,
        default: null
      },
      topic: {
        type: Number,
        default: null
      },
      labels: {
        type: Object,
        default: function () {
          return {type: this.$tc("common.messaging.comment",1), pluralType: this.$tc("common.messaging.comment",2), buttonLabel: this.$t("common.messaging.send")}
        }
      },
      allowReply: {
        type: Boolean,
        default: true
      },
      blocked: {
        type: Boolean,
        default: false
      },
      bodyPlaceholder: {
        type: String,
        default: "Say something nice..."
      },
      readOnly: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        comments: [],
        nextOffset: 0,
        order: null,
        totalComments: null,
        loading: false,
        newOrder: null,
        addDialog: false,
        highlightParam: null,
        highlight: null
      }
    },
    mounted() {
      if (this.$route.query.highlight) {
        this.highlightParam = this.$route.query.highlight
        let el = document.getElementById("messaging-block")
        if (el) {
          el.scrollIntoView()
        }

      }
      this.loadMessages()
    },
    computed: {
      showingText() {
        if (!this.highlight) {
          if (this.totalComments == this.comments.length) return "All Shown"
          else return "" + this.comments.length + " Shown"
        }

      },
      showingTextSmall() {
        if (this.highlight) return "View is limited in order to <span class='yellow lighten-4'>highlight</span> a comment. Refresh to see all."
        else return ""
      }
    },
    methods: {
      returnTopics() {
        this.$emit("closeTopic")
      },
      async postComment(msg) {
        this.addDialog = false
        await this.$store.dispatch("setExecuting", true)
        let url = "/message/" + this.type + "/" + this.id + "/create"
        api.post(url, {messageText: msg.text, subject: msg.subject, postAsAdmin: msg.postAsAdmin, pastedImages: msg.pastedImages}).then(
          async (results) => {
            this.totalComments++
            if (msg.files) {
              await this.attachFiles(results.data.message, msg.files)
            }

            if (this.order == "asc") this.comments.push(results.data.message)
            else this.comments.unshift(results.data.message)
          },
          (error) => {
            this.$notify.error({message: "Could not post comment. " + error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      async attachFiles(message, files) {
        const reduce = require('image-blob-reduce')();
        for (let file of files) {
          let toUpload = file
          try {
            if (file.size >= 2000000) {
              console.log("Reducing file ", file)
              await reduce.toBlob(file, {max: 2000})
                .then(blob => {
                  toUpload = blob
                })
            }
            await api.postImage("/message/image/" + message.id, toUpload).then(
              (results) => {
                message.attachments.push(results.data)
              },
              (error) => {
                this.$notify.error({message: error.response.data, timeOut: 5000})
              })
          }
          catch (e) {
            console.log("Error loading image ", toUpload, e)
          }
        }
      },
      refresh() {
        this.comments = []
        this.highlight = null
        this.loadMessages()
      },
      changeDir(d) {
        this.comments = []
        this.newOrder = d
        this.loadMessages()
      },
      loadMessages() {
        this.loading = true
        let url = "/message/" + this.type + "/" + this.id + "/get/"
        url += "?h=a" //hack so all requests have 1 param
        if (this.topic) url += "&topic=" + this.topic
        if (this.highlightParam) {
          url += "&highlight=" + this.highlightParam
          this.highlight = this.highlightParam
          this.highlightParam = null //so not highlighted on refresh
        } else if (this.newOrder) url += "&order=" + this.newOrder
        else if (this.nextOffset > 0) url += "&offset=" + this.nextOffset
        api.get(url).then(
          (results) => {
            this.event = results.data;
            this.comments.push.apply(this.comments, results.data.comments)
            this.totalComments = results.data.totalComments
            this.nextOffset = results.data.nextOffset
            this.order = results.data.order
            this.newOrder = null
          },
          (error) => {
            if (error.response.status != 401) this.$notify.error({
                                                                   message: "Could not load comments. " + error.response.data,
                                                                   timeOut: 20000
                                                                 })
          }).then(() => {
          this.loading = false
        })
      },
      commentDeleted(c) {
        let loc = this.comments.indexOf(c)
        this.comments.splice(loc, 1)
        this.totalComments--
      },
      replyDeleted(c, r) {
        let loc = c.replies.indexOf(r)
        c.replies.splice(loc, 1)
        c.totalReplies--
      }

    }

  };
</script>
<style scoped>
  .toolbar-buttons {
    float: right;
  }

  .toolbar-buttons a {
    color: #ffffff;
  }

  .toolbar-buttons a {
    padding-left: 5px;
  }


</style>
